import React from 'react';
import PropTypes from 'prop-types';
import {truncate} from 'lodash';
import Card from 'src/components/Cards/Card';
import Icon from 'shared/components/icon';

const propTypes = {
  isDeleted: PropTypes.bool,
  url: PropTypes.string,
  deletePhoto: PropTypes.func,
};

const CollegePhoto = (props) => {
  const {isDeleted, url, deletePhoto} = props;

  return (
    <Card className="admin-portal-college-photo-card">
      <div className="admin-portal-college-photo-container" data-testid="college-photo">
        <a
          className="admin-portal-college-photo-link"
          href={url}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img className="admin-portal-college-photo" alt={url} src={url} />
        </a>
      </div>
      <div className="admin-portal-college-photo-controls">
        <span>{truncate(url.split('/').slice(-1).join(''), 18, '...')}</span>
        <Icon
          className="admin-portal-college-photo-toggle"
          size={24}
          onClick={deletePhoto(url)}
          iconType={isDeleted ? 'redo-alt' : 'times-circle'}
        />
      </div>
    </Card>
  );
};

CollegePhoto.propTypes = propTypes;
export default CollegePhoto;
